import { createFileRoute, notFound } from '@tanstack/react-router'
import CostCentrePageHeader from '../../Pages/CostCentrePage/CostCentrePageHeader'
import CostCentrePage from '../../Pages/CostCentrePage/CostCentrePage'
import PageBody from '../../Pages/Layout/PageBody'
import { processTRPCData } from '../../Queries/fetchData'
import LoadingSpinner from '../../Components/LoadingSpinner'
import ErrorComponent from '../../Components/ErrorComponent'
import {
    canViewRoute,
    migratedToV2,
} from '../../State/Permissions/HasPermissions'
import SessionStore from '../../State/SessionStore'
import PermissionDenied from '../../Pages/PermissionDenied'
import DataStore from '../../State/DataStore'
import { router } from '../../App'
import CostCentreCollection from '../../State/Collections/CostCentreCollection'
import { CenterPadPageBody } from '@2/layout/page-body'
import { trpc } from '../../system/trpc'

export const Route = createFileRoute('/_private/cost-centres/$id')({
    beforeLoad: ({ params }) => {
        if (!canViewRoute(SessionStore.user, 'costCentre', params))
            throw new Error('Permission Denied')
    },
    errorComponent: ({ error, reset }) => {
        if (error.message === 'Permission Denied') return <PermissionDenied />
        return <ErrorComponent error={error} reset={reset} />
    },
    loader: async ({ params }) => await loader(params.id),
    pendingComponent: LoadingSpinner,
    component: Wrapper,
    onLeave: (match) => {
        const { id } = match.params
        const costCentre = CostCentreCollection.costCentresById[id]
        if (
            !costCentre?.createdAt &&
            match.pathname !== router.latestLocation.pathname
        ) {
            DataStore.destroyNewItems('costCentreId', id)
        }
    },
})

const loader = async (id) => {
    const data = await trpc.legacy.getCostCentrePageData.query({
        costCentreId: id,
    })
    const processedModels = processTRPCData(data)
    const costCentre = CostCentreCollection.costCentresById[id]
    if (!costCentre) {
        throw notFound()
    }
    return processedModels
}

function Wrapper() {
    const { id } = Route.useParams()
    if (migratedToV2()) {
        return (
            <CenterPadPageBody>
                <CostCentrePage costCentreId={id} />
            </CenterPadPageBody>
        )
    }
    return (
        <>
            <CostCentrePageHeader id={id} />
            <PageBody>
                <CostCentrePage id={id} />
            </PageBody>
        </>
    )
}
